import React from 'react'
import PropTypes from 'prop-types'
import Flex from '../Flex'
import Box from '../Box'
import { STATUS_TYPES, StepExtraInfoContainer, StepName, StepProgressContainer, StepsSeparator } from './StepsIndicator.styles'
import StepProgress from './StepProgress'
import { StepsTitle, StepsTitleMobile } from './StepData.styles'
import Icon from '../Icon'

const StepData = ({ editIcon, stepTitle, stepMobileTitle, extraInfoComponent, currentStep, totalSteps, nextStatus, status, goToStep }) =>
    <Flex flexDirection='column' width='100%'>
        <Flex flexDirection='row' alignItems='center' width='100%'>
            <StepName onClick={goToStep} status={status} width='100%'>
                <StepProgressContainer flexDirection='row' alignItems='center' justifyContent={['center', 'center', 'flex-start']} width='100%'>
                    <Box w={['100%', '100%', '35px']}>
                        <StepProgress currentStep={currentStep} totalSteps={totalSteps} status={status} nextStatus={nextStatus} />
                    </Box>
                    <StepsTitle>
                        {stepTitle}
                    </StepsTitle>
                    <Box flex='1' display={['none', 'none', 'block']} padding='0 5px'>
                        <StepsSeparator status={status} />
                    </Box>
                    <StepsTitleMobile>
                        {stepMobileTitle}
                        <Flex marginLeft='4px' alignItems='flex-start' onClick={goToStep}>
                            {editIcon}
                        </Flex>
                    </StepsTitleMobile>
                </StepProgressContainer>
            </StepName>
        </Flex>
        {extraInfoComponent && <StepExtraInfoContainer pl='38px' onClick={goToStep}>
            <Box maxWidth='calc(100% - 30px)'>
                {extraInfoComponent}
            </Box>
            <Box textAlign='center' width='40px'>
                <Flex marginLeft='4px' alignItems='flex-start' onClick={goToStep}>
                    {editIcon}
                </Flex>
            </Box>
        </StepExtraInfoContainer>}
    </Flex>

StepData.propTypes = {
    editIcon: PropTypes.node,
    stepTitle: PropTypes.node,
    stepMobileTitle: PropTypes.node,
    extraInfoComponent: PropTypes.node,
    currentStep: PropTypes.number,
    totalSteps: PropTypes.number,
    status: PropTypes.oneOf(STATUS_TYPES),
    nextStatus: PropTypes.oneOf(STATUS_TYPES),
    goToStep: PropTypes.func,
}

StepData.defaultProps = {
    editIcon: <Icon size='small' type='pencil' color='gray' />,
}

export default StepData
